/* Terjung Slider-Pfeile (2026-10-09, v2): Pfeile links/rechts statt Navigation unten.
   Gilt für Produkt-, Kategorie- und Rezept-Slider (css-slider). Pfeil blendet sich am Rand aus.
   v2: übersteht destroySlider()/initSlider() (Rezept-Finder baut seine Slider beim Aufklappen neu auf). */
(() => {
  const SELECTORS = ['.product-item', '.js-collection-item', '.terjung-rf__tile-item', '.terjung-rf__recipe-item'];
  const svg = (d) => '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ICONS = { prev: svg('M15 5l-7 7 7 7'), next: svg('M9 5l7 7-7 7') };

  const itemSelector = (slider) => {
    try { return JSON.parse(slider.getAttribute('data-options') || '{}').selector || ''; } catch (e) { return ''; }
  };
  const holderOf = (slider) => slider.querySelector(':scope > .css-slider-viewport > .css-slider-holder');

  function update(slider) {
    const holder = holderOf(slider);
    const prev = slider.querySelector(':scope > .tj-arrow--prev');
    const next = slider.querySelector(':scope > .tj-arrow--next');
    if (!holder || !prev || !next) return;
    const max = holder.scrollWidth - holder.clientWidth;
    const pos = Math.abs(holder.scrollLeft);
    prev.hidden = pos <= 4;
    next.hidden = max <= 4 || pos >= max - 4;
  }

  function enhance(slider) {
    if (!SELECTORS.includes(itemSelector(slider))) return;
    if (!holderOf(slider)) return;
    slider.classList.add('tj-arrows');
    if (!slider.dataset.tjArrows) {
      slider.dataset.tjArrows = '1';
      // scroll bubbelt nicht -> Capture am Slider, funktioniert auch mit neu aufgebautem Holder
      slider.addEventListener('scroll', () => update(slider), { capture: true, passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => update(slider)).observe(slider);
    }
    for (const dir of ['prev', 'next']) {
      if (slider.querySelector(':scope > .tj-arrow--' + dir)) continue;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'tj-arrow tj-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Vorherige anzeigen' : 'Weitere anzeigen');
      b.insertAdjacentHTML('afterbegin', ICONS[dir]);
      b.hidden = true;
      b.addEventListener('click', () => {
        const holder = holderOf(slider);
        if (!holder) return;
        const step = Math.max(holder.clientWidth * 0.85, 200) * (dir === 'prev' ? -1 : 1);
        holder.scrollBy({ left: document.documentElement.dir === 'rtl' ? -step : step, behavior: 'smooth' });
      });
      slider.appendChild(b);
    }
    update(slider);
  }

  const run = () => document.querySelectorAll('css-slider').forEach(enhance);
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; setTimeout(() => { queued = false; run(); }, 60); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  // Neu aufgebaute oder spät initialisierte Slider (Holder entsteht erst nach dem Connect)
  new MutationObserver((records) => {
    for (const r of records) {
      const t = r.target;
      if (t.nodeType === 1 && (t.matches('css-slider, .css-slider-viewport') || t.closest('css-slider'))) { schedule(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
